export enum PageNotFoundRoutes {
  root = '404',
}
